import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button, Input } from '../../../node_modules/semantic-ui-react';
import Select from 'react-select';
import { handleNumericOnKeyDown, handleNumericOnKeyPress } from '../../utils';
import SelectEmployees from '../../Commons/SelectEmployees';
import FilterGroupSection, { emptyFilterGroup, normalizeFilterGroup } from '../../Commons/FilterGroupSection';

const appliedCutoffOptions = {
    MONTHLY: [
        { label: "Every Cutoff", value: "EVERY_CUTOFF" }
    ],
    SEMIMONTHLY: [
        { label: "First Cutoff", value: "FIRST_CUTOFF" },
        { label: "Second Cutoff", value: "SECOND_CUTOFF" },
        { label: "Every Cutoff", value: "EVERY_CUTOFF" }
    ],
    WEEKLY: [
        { label: "First Cutoff", value: "FIRST_CUTOFF" },
        { label: "Second Cutoff", value: "SECOND_CUTOFF" },
        { label: "Third Cutoff", value: "THIRD_CUTOFF" },
        { label: "Fourth Cutoff", value: "FOURTH_CUTOFF" },
        { label: "Fifth Cutoff", value: "FIFTH_CUTOFF" },
        { label: "Every Cutoff", value: "EVERY_CUTOFF" }
    ]
};

class OvertimePremiumReportModal extends Component {
    constructor(props) {
        super(props);
        var today = new Date();
        var defaultState = {
            Year:parseInt(today.getFullYear()),
            Month:today.getMonth() + 1,
            filterGroup: emptyFilterGroup(),
            EmployeeIds:[],
            includeEmptyEntries:false,
            includeAmount : true,
            searchQuery:'',
            selectedFrequency: 'MONTHLY',
            selectedAppliedCutoff: 'EVERY_CUTOFF',
        };

        const savedState = sessionStorage.getItem("OvertimePremiumFilterState");
        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.state = { ...defaultState, ...parsed, filterGroup: normalizeFilterGroup(parsed.filterGroup) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            Year: this.state.Year,
            Month: this.state.Month,
            EmployeeIds: this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries,
            includeAmount: this.state.includeAmount,
            selectedFrequency: this.state.selectedFrequency,
            selectedAppliedCutoff: this.state.selectedAppliedCutoff,
        };
        sessionStorage.setItem("OvertimePremiumFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            fromDate:  this.state.Year + '-' + this.state.Month + '-01', 
            toDate: this.state.Year + '-' +  this.state.Month + '-' + new Date(this.state.Year, this.state.Month, 0).getDate(), 
            ...this.state.filterGroup,
            message: "from overtime premium modal",
            selectedFrequency: this.state.selectedFrequency,
            appliedCutoff: this.state.selectedFrequency === "MONTHLY" ? "EVERY_CUTOFF" : this.state.selectedAppliedCutoff,
            EmployeeIds: this.state.EmployeeIds,
            includeEmptyEntries: this.state.includeEmptyEntries,
            includeAmount : this.state.includeAmount
        };
    }

    updateEmployeeIds = (ids) =>{
        this.setState({ EmployeeIds: ids});
    }
    
    handleCheckChange = (e) =>{
        e.target.textContent === "Include Amount" ?
        this.setState(prevState => ({ includeAmount: !prevState.includeAmount})) :
        this.setState(prevState => ({ includeEmptyEntries : !prevState.includeEmptyEntries }));
    }

    handleDropDownChange = name => event => {
        var current = this.state.selectedFrequency;
        if (!(event === undefined || event === null)) {
            current = event.value;
        } else {
            current = ""
        }
        if (current === "MONTHLY" || current === "SEMIMONTHLY" || current === "WEEKLY"){
            this.setState({ selectedFrequency: current, selectedAppliedCutoff: "EVERY_CUTOFF" });
        }else{
            this.setState({ Month: current });
        }
    }

    render() {

        const months = [
            { label:  'January', value: 1 },
            { label:  'Febuary', value: 2 },
            { label:  'March', value: 3 },
            { label:  'April', value: 4 },
            { label:  'May', value: 5 },
            { label:  'June', value: 6 },
            { label:  'July', value: 7 },
            { label:  'August', value: 8 },
            { label:  'September', value: 9 },
            { label:  'October', value: 10 },
            { label:  'November', value: 11 },
            { label: 'December', value: 12 },
        ];

        const frequencyType = [
            { label: "MONTHLY", value: "MONTHLY" },
            { label: "SEMI-MONTHLY", value: "SEMIMONTHLY" },
            { label: "WEEKLY", value: "WEEKLY"}
        ];

        const cutoffOptions = appliedCutoffOptions[this.state.selectedFrequency] || appliedCutoffOptions.MONTHLY;
        const hasCompany = this.state.filterGroup.companyIds.length > 0;

        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Report Filters</p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <label>Cut off Frequency</label>
                                <Select value={frequencyType.find(x => x.value === this.state.selectedFrequency)}
                                        options={frequencyType}
                                        onChange={this.handleDropDownChange("frequency").bind(this)}
                                />
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <label>Applied Cutoff</label>
                                <Select value={cutoffOptions.find(x => x.value === this.state.selectedAppliedCutoff) || cutoffOptions.find(x => x.value === "EVERY_CUTOFF")}
                                        options={cutoffOptions}
                                        onChange={(e) => this.setState({ selectedAppliedCutoff: e ? e.value : "EVERY_CUTOFF" })}
                                        isDisabled={this.state.selectedFrequency === "MONTHLY"}
                                />
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned eight wide column">
                            <label>Month</label>
                            <Select label = "Month" value={months.find(x => x.value === this.state.Month)}
                                    options={months}
                                    onChange={this.handleDropDownChange("Months").bind(this)}
                            />
                        </div>
                        <div class="right floated right aligned eight wide column">
                            <label style={{marginRight:'100%'}}>Year</label>
                            <Input fluid value={this.state.Year}
                                onChange={(e) => this.setState({ Year: e.target.value })}
                                onKeyPress={(e) => handleNumericOnKeyPress(e)}
                                onKeyDown={(e) => handleNumericOnKeyDown(e)}
                            /> 
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                            {!hasCompany && <label style={{ fontSize: '13px', fontStyle: 'italic' }}>Select at least one Company.</label>}
                        </div>
                    </div>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <label>Employee</label>
                            <SelectEmployees filterGroup={this.state.filterGroup} Ids={this.state.EmployeeIds} update={this.updateEmployeeIds.bind(this)}/>
                        </div>
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button positive content="Generate" onClick={this.props.onSave} disabled={!hasCompany}></Button>
                    <Button negative content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default OvertimePremiumReportModal;